import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

export const PrimaryButton = ({ label = "Contact Us" }) => (
  <Link
    to="/contact"
    data-cursor="link"
    className="bg-teal-200 text-white px-6 py-2 rounded-full font-semibold shadow hover:bg-teal-500 transition group inline-block btn-pop"
  >
    <span className="flex items-center">
      {label}
      <FaArrowRightLong className="mt-[6px] ml-2 hidden group-hover:inline-block group-hover:translate-x-1 transition-transform duration-300 ease-in-out" />
    </span>
  </Link>
);

export const PrimaryButton2 = ({ label, onClick, ...props }) => {
  return (
    <button
      onClick={onClick}
      {...props}
      data-cursor="button"
      className="group bg-teal-200 text-white px-6 py-2 rounded-full font-semibold shadow hover:bg-teal-500 transition-all duration-300 ease-in-out flex items-center btn-pop"
    >
      <span className="transition-all duration-300 ease-in-out group-hover:pr-2">
        {label}
      </span>
      <FaArrowRightLong
        className="ml-0 w-0 opacity-0 group-hover:ml-2 group-hover:w-4 group-hover:opacity-100 transition-all duration-300 ease-in-out"
      />
    </button>
  );
};

export const ApplyButton = ({
  label,
  colorClass = "text-fuchsia-600 bg-white hover:bg-white-500",
}) => {
  return (
    <button
      data-cursor="button"
      className={`group ${colorClass} font-bold px-6 py-2 rounded-full transition-all duration-300 ease-in-out flex items-center shadow-2xl btn-pop`}
    >
      <span className="transition-all duration-300 ease-in-out group-hover:pr-2">
        {label}
      </span>
      <FaArrowRightLong
        className="ml-0 w-0 opacity-0 group-hover:ml-2 group-hover:w-4 group-hover:opacity-100 transition-all duration-300 ease-in-out"
      />
    </button>
  );
};
export const CustomButton = ({
  label,
  colorClass = "text-fuchsia-600 bg-white hover:bg-white-500",
}) => {
  return (
    <button
      data-cursor="button"
      className={`group ${colorClass} font-bold px-6 py-2 rounded-full transition-all duration-300 ease-in-out flex items-center shadow-2xl btn-pop`}
    >
      <span className="transition-all duration-300 ease-in-out group-hover:pr-2">
        {label}
      </span>
      <FaArrowRightLong
        className="ml-0 w-0 opacity-0 group-hover:ml-2 group-hover:w-4 group-hover:opacity-100 transition-all duration-300 ease-in-out"
      />
    </button>
  );
};
export const SecondaryButton2 = ({ label }) => {
  return (
    <button data-cursor="button" className="group bg-orange-400 text-white  px-6 py-2 rounded-full font-semibold shadow hover:bg-orange-500 transition-all duration-300 ease-in-out flex items-center btn-pop">
      <span className="transition-all duration-300 ease-in-out group-hover:pr-2">
        {label}
      </span>
      <FaArrowRightLong
        className="ml-0 w-0 opacity-0 group-hover:ml-2 group-hover:w-4 group-hover:opacity-100 transition-all duration-300 ease-in-out"
      />
    </button>
  );
};
